import { Preferences } from '@capacitor/preferences';
import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

    constructor() { }

    public async set(key: string, value: any): Promise<void> {
        await Preferences.set({
            key: key,
            value: JSON.stringify(value)
        });
    }

    public async get(key: string): Promise<any> {
        const item = await Preferences.get({ key: key });
        return JSON.parse(item.value);
    }

    public async getMultiple(keys): Promise<any> {

        let data: any = {};

        for (let i = 0; i < keys.length; i++) {

            const item = await Preferences.get({ key: keys[i] });

            if(item.value != null) {
                data[keys[i]] = JSON.parse(item.value);
            }

        }

        return data;
    }

    public async remove(key: string): Promise<void> {
        await Preferences.remove({
            key: key
        });
    }

    public async clear(): Promise<void> {
        await Preferences.clear();
    }

}
